import React from "react";
import {Drawer} from "@mui/material";
import {sidebarClass} from "../../resources/environment";
import {useSidebar} from "./Context/SidebarProvider";
import {SidebarContent} from "./SidebarContent";
import {useSidebarStyles} from "./sidebarStyles";

export const SidebarNew = () => {
  const {isSidebarHidden, xsScreen, showSidebarText} = useSidebar();
  const {classes} = useSidebarStyles({newSidebarDesign: true, showSidebarText});
  const sidebarHiddenClass = isSidebarHidden && xsScreen ? `${sidebarClass}` : "";

  return (
    <div className={`${classes.root} ${sidebarHiddenClass}`} id="sidebar">
      <Drawer
        className={`${classes.drawer} ${sidebarHiddenClass}`}
        variant="permanent"
        classes={{paper: classes.drawerPaper}}
      >
        <div id="sidebar-content" className={classes.sidebarContent}>
          <SidebarContent />
        </div>
      </Drawer>
    </div>
  );
};
